<div
  *ngIf="!theme || theme !== 'attention'"
  class="notification"
  [ngClass]="{
    'notification--alarm': type === 'alarm',
    'notification--attention': type === 'attention',
    'notification--text-align_end': textAlign === 'end',
    'notification--text-align_start': textAlign === 'start',
    'notification--no-margin': noMargin
  }"
>
  <div class="notification__wrapper">
    <div *ngTemplateOutlet="content"></div>
  </div>
</div>

<card-wrapper *ngIf="theme === 'attention'">
  <div class="notification-attention">
    <icon width="24px" height="24px" name="attention" color="#FF0000" class="notification-attention__icon"></icon>
    <div class="notification-attention__text"><div *ngTemplateOutlet="content"></div></div>
  </div>
</card-wrapper>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
